import * as Sentry from "@sentry/react";
import localStorageKey from "../enumerations/localStorageKey";

export const removeLocalStorageData = () => {
  window.localStorage.removeItem(localStorageKey.TOKEN);
  window.localStorage.removeItem(localStorageKey.CART);
  window.localStorage.removeItem(localStorageKey.USER_ACCOUNT);
  window.localStorage.removeItem(localStorageKey.EMAIL_VERIFY_SEND_TIME);
  window.localStorage.removeItem(localStorageKey.PROMOTE_CODE);
  window.localStorage.removeItem(localStorageKey.GIFT_POINT);

  Sentry.setUser(null);
};
